import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography } from '@mui/material';
import Amount from '@components/common/molecules/Amount';
import OrderEditViewStore from '@components/order/stores/OrderEditViewStore';

interface OrderDeliveryInfoProps {
    orderEditViewStore: OrderEditViewStore;
}

const OrderDeliveryInfo: React.FC<OrderDeliveryInfoProps> = observer(({ orderEditViewStore }) => {
    const { totalAmount, deliveryFee, addressOption, restaurant, isMinOrderAmountForDeliveryConditionValid } = orderEditViewStore;

    if (addressOption !== 'user-address') {
        return (
            <Box display={"flex"} flexDirection={"row"}>
                <Typography variant='caption' sx={{ height: { xs: 17.422, sm: 19.91 } }}> </Typography>
            </Box>
        )
    }
    else if (!isMinOrderAmountForDeliveryConditionValid) {
        return (
            <Box display={"flex"} flexDirection={"row"} width={"100%"} justifyContent={"flex-end"}>
                <Typography variant='caption'>Minimalni iznos narudžbe za dostavu je {restaurant?.minOrderAmountForDelivery} KM.</Typography>
            </Box>
        );
    }
    else if (deliveryFee === null) {
        return (
            <Box display={"flex"} flexDirection={"row"} width={"100%"} justifyContent={"flex-end"}>
                <Typography variant='caption'>Moguća naplata dostave.</Typography>
            </Box>
        );
    }
    else {
        return (
            <Box display={"flex"} flexDirection={"row"} width={"100%"} justifyContent={"flex-end"}>
                <Typography variant='caption' flexGrow={1}>Dostava:</Typography>
                <Amount variant='caption' fontWeight={600} amount={totalAmount} />
            </Box>
        );
    }
})


export default OrderDeliveryInfo;